import React, { useEffect, useState } from "react";
import { Card, TextContainer, Icon } from "@shopify/polaris";

import {
  MarkFulfilledMinor,
  AppExtensionMinor,
  PaymentsMajor,
  OrdersMajor,
  TapChipMajor,
  DisputeMinor,
  EnvelopeMajor,
  OrderStatusMinor,
  ConversationMinor,
} from "@shopify/polaris-icons";
import { Row, Col } from "reactstrap";

import { useSelector } from "react-redux";
import config from "../../config/config";
import Dispute from "../Dispute";
import callApi from "../../utils/apiCaller";

const Analysis = (props) => {
  const [dataAnalysis, setdataAnalysis] = useState({
    total: 0,
    waiting: 0,
    review: 0,
    resolved: 0,
  });

  useEffect(() => {
    let params = {
      action: "getDisputeAnalysis",
      time: props.timeSelected,
    };
    callApi("get", params).then(async (res) => {
      if (res.data.state === 1) {
        setdataAnalysis(res.data.dataAnalysis);
      }
    });
  }, [props.timeSelected]);

  return (
    <Row className="statistical-layout-row w-100">
      <Col xs="12" sm="12" md="6" lg="3">
        <Card sectioned>
          <div className="statistical-layout text-center">
            <div
              className="statistical-layout-icon"
              style={{
                backgroundColor: "#aee9d1",
                margin: "auto",
                borderRadius: "50%",
              }}
            >
              <Icon color="white" source={DisputeMinor} />
            </div>
            <div className="statistical-layout-text">
              <TextContainer>
                <b className="title mt-5">Total Disputes</b>
                <p className="value">{dataAnalysis.total}</p>
              </TextContainer>
            </div>
          </div>
        </Card>
      </Col>
      <Col xs="12" sm="12" md="6" lg="3">
        <Card sectioned>
          <div className="statistical-layout text-center">
            <div
              className="statistical-layout-icon"
              style={{
                backgroundColor: "#aee9d1",
                margin: "auto",
                borderRadius: "50%",
              }}
            >
              <Icon color="white" source={ConversationMinor} />
            </div>
            <div className="statistical-layout-text">
              <TextContainer>
                <b className="title mt-5">Wait to response</b>
                <p className="value">{dataAnalysis.waiting}</p>
              </TextContainer>
            </div>
          </div>
        </Card>
      </Col>
      <Col xs="12" sm="12" md="6" lg="3">
        <Card sectioned>
          <div className="statistical-layout text-center">
            <div
              className="statistical-layout-icon"
              style={{
                backgroundColor: "#aee9d1",
                margin: "auto",
                borderRadius: "50%",
              }}
            >
              <Icon color="white" source={OrderStatusMinor} />
            </div>
            <div className="statistical-layout-text">
              <TextContainer className>
                <b className="title">Under review</b>
                <p className="value">{dataAnalysis.review}</p>
              </TextContainer>
            </div>
          </div>
        </Card>
      </Col>
      <Col xs="12" sm="12" md="6" lg="3">
        <Card sectioned>
          <div className="statistical-layout text-center">
            <div
              className="statistical-layout-icon"
              style={{
                backgroundColor: "#aee9d1",
                margin: "auto",
                borderRadius: "50%",
              }}
            >
              <Icon color="white" source={MarkFulfilledMinor} />
            </div>
            <div className="statistical-layout-text">
              <TextContainer className>
                <b className="title">Resolved</b>
                <p className="value">{dataAnalysis.resolved}</p>
              </TextContainer>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default Analysis;
